import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { DEFAULT_SALES_TAX_CONFIG } from '~/features/salesTax/types';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { QueryKeys } from '../queryKeys';
import { useUpdateSalesTaxConfig } from './useUpdateSalesTaxConfig';
export const useSalesTaxConfig = function useSalesTaxConfig() {
    let { enabled = true, refreshOnHookMount = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { data, isLoading, getQueryData } = useQueryState({
        queryKey: [
            QueryKeys.SalesTaxConfig
        ],
        // TODO(ANCR-20-BE): read the business settings sales-tax config (worksAt.settings.salesTax) once Phase 12 wires the endpoint.
        queryFn: async ()=>DEFAULT_SALES_TAX_CONFIG,
        enabled,
        refreshOnHookMount
    });
    const { updateSalesTaxConfig } = useUpdateSalesTaxConfig();
    const config = data !== null && data !== void 0 ? data : DEFAULT_SALES_TAX_CONFIG;
    const setConfig = (next)=>updateSalesTaxConfig(next);
    const updateConfig = (patch)=>{
        var _getQueryData;
        return updateSalesTaxConfig(_object_spread({}, (_getQueryData = getQueryData()) !== null && _getQueryData !== void 0 ? _getQueryData : config, patch));
    };
    return {
        config,
        isLoading,
        setConfig,
        updateConfig
    };
};
